export enum DistributionChannel {
    Broker = 0,
    AG = 1
}
